import styled from "@emotion/styled";
import type { ReactNode } from "react";

import {
  AgentSurfaceNavigation,
  AgentSurfaceNavigationActiveTab,
} from "@/pages/agent/components/agent-surface-navigation";

export const AgentPageLayout = ({
  activeTab,
  fillsViewport = false,
  children,
}: {
  activeTab: AgentSurfaceNavigationActiveTab;
  /**
   * Pins the surface to the overlay height so a child can claim the leftover
   * space and scroll inside it. Surfaces that grow with their content and let
   * the overlay scroll leave this off.
   */
  fillsViewport?: boolean;
  children: ReactNode;
}) => (
  <StyledRoot $fillsViewport={fillsViewport}>
    <AgentSurfaceNavigation activeTab={activeTab} />
    {children}
  </StyledRoot>
);

export const AgentPageFilterBar = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing[2]};
`;

const StyledRoot = styled.div<{ $fillsViewport: boolean }>`
  background: ${({ theme }) => theme.colors.surface.onboarding};
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[5]};
  height: ${({ $fillsViewport }) => ($fillsViewport ? "100%" : "auto")};
  margin: 0 auto;
  max-width: 968px;
  min-height: 100%;
  padding: ${({ theme }) => theme.spacing[8]} 0 ${({ theme }) => theme.spacing[10]};
  width: calc(100% - ${({ theme }) => theme.spacing[10]} * 2);

  @media (max-width: 720px) {
    width: calc(100% - ${({ theme }) => theme.spacing[4]} * 2);
  }
`;
